/**
 * Toast "Agregado al carrito" cuando el carrito está por debajo del mínimo (50 soles).
 * Escucha theme:product:added:below_min y muestra/oculta el toast.
 */
(function () {
  var TOAST_DURATION_MS = 2800;
  var toastEl = document.getElementById('add-to-cart-toast');
  var hintEl = toastEl && toastEl.querySelector('[data-toast-hint]');
  var timeoutId = null;

  function showToast(detail) {
    if (!toastEl) return;
    if (timeoutId) clearTimeout(timeoutId);

    if (hintEl) {
      hintEl.textContent = '';
    }

    toastEl.setAttribute('aria-hidden', 'false');
    toastEl.classList.add('is-visible');

    timeoutId = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      toastEl.setAttribute('aria-hidden', 'true');
      timeoutId = null;
    }, TOAST_DURATION_MS);
  }

  document.addEventListener('theme:product:added:below_min', function (e) {
    showToast(e.detail || {});
  });
})();
